import React from "react"
import { sampleItem } from "@/routes/(app)/_layout/inventory/$itemId/-data/fixtures"
import KeyVal from "./key-val"

export default function RightInfoContent({ subTab }: { subTab: "overview" | "gtins" }) {
  const item = sampleItem

  if (subTab === "gtins") {
    const gtin13 = item.gtins[0]?.code || "5901234123457"
    const gtin14 = item.gtins[1]?.code || "15901234123458"
    const sku = "PZR-IBU-200-N"

    return (
      <div className="rounded-xl border border-gray-200 overflow-hidden">
        <div className="p-4">
          <div className="text-base font-semibold">GTIN-13 (EAN)</div>
          <div className="text-sm text-muted-foreground">Product barcodes</div>
          <div className="mt-3 inline-block rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900">
            {gtin13}
          </div>
        </div>
        <div className="border-t border-gray-200 p-4">
          <div className="text-base font-semibold">GTIN-14 (ITF-14)</div>
          <div className="text-sm text-muted-foreground">Custom barcodes</div>
          <div className="mt-3 inline-block rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900">
            {gtin14}
          </div>
        </div>
        <div className="border-t border-gray-200 p-4">
          <div className="text-base font-semibold">SKU</div>
          <div className="text-sm text-muted-foreground">Internal stock keeping unit</div>
          <div className="mt-3 inline-block rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900">
            {sku}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      <KeyVal label="ITEM CODE" value={item.overview.itemCode} />
      <KeyVal label="MANUFACTURER" value={item.overview.manufacturer} />
      <KeyVal label="STORAGE CONDITION" value={item.overview.storageCondition} />
      <KeyVal label="CATEGORY" value={item.overview.category} muted />
      <KeyVal label="REGISTRATION NUMBER" value={item.overview.registrationNumber} />
      <KeyVal label="SCIENTIFIC NAME (IUPAC)" value={item.overview.scientificName} />
      <KeyVal label="ACTIVE INGREDIENT" value={item.overview.activeIngredient} link />
      <KeyVal label="DOSAGE FORM" value={item.overview.dosageForm} muted />
      <KeyVal label="ADMINISTRATION" value={item.overview.administration} muted />
      <KeyVal label="PHARMA CLASS" value={item.overview.pharmaClass} muted />
      <div className="mt-3">
        <div className="text-sm font-medium mb-2">Clinical Notes</div>
        <div className="rounded-lg bg-yellow-50 border border-yellow-200 p-3 text-sm">
          {item.overview.clinicalNotes}
        </div>
      </div>
    </div>
  )
}
